/*
 * Copyright (c) 2022-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'
import { Role } from './Role.js'

export const TokenVerifyResponse = z.object({
  accessToken: z.string().nullish(),
  active: z.boolean(),
  clientID: z.string().nullish(),
  expiresIn: z.number().int().nullish(),
  refreshToken: z.string().nullish(),
  roles: z.array(Role).nullish(),
  scope: z.string().nullish(),
  tokenType: z.string().nullish(),
  userId: z.string().nullish()
})

export interface TokenVerifyResponse extends z.TypeOf<typeof TokenVerifyResponse> {}
